import { render, staticRenderFns } from "./contragents.vue?vue&type=template&id=4053c0c4"
import script from "./contragents.vue?vue&type=script&lang=js"
export * from "./contragents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports